import React, {
  useMemo,
} from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import isNil from 'lodash/isNil';
import keys from 'lodash/keys';
import isEmpty from 'lodash/isEmpty';
import negate from 'lodash/negate';
import {
  pluralize,

  notEmptyString,
} from '@populateui/utils';
import MultiChoiceGroup from 'core/components/MultiChoiceGroup';
import NumberTextField from 'core/components/NumberTextField';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import Select from 'core/components/Select';
import {
  daysOfWeek,
} from 'core/constants';
import {
  eventRecurrenceMap,
} from 'pages/Dashboard/pages/Appointments/pages/List/utils/helper';
import {
  CommonOption,
} from 'pages/Dashboard/pages/Appointments/pages/List/types/appointment';
import {
  useFormAutoFocus,
} from 'views/EMR/hooks/common';

export default function RecurrenceFields() {
  const { control, watch } = useFormContext();
  const [
    repeatType,
    repeatInterval,
  ] = watch([
    'recurrence.repeatType',
    'recurrence.interval',
  ]);
  const isWeekly = /^weekly$/i.test(repeatType?.id);
  const recurrenceOptions = useMemo(() => (
    keys(eventRecurrenceMap).map((recurrence) => ({
      label: pluralize(eventRecurrenceMap[recurrence], Number(repeatInterval), false),
      id: recurrence,
    }))
  ), [repeatInterval]);

  const inputRef = useFormAutoFocus();

  return (
    <div className="mt-2">
      <div className="flex items-center gap-form-field">
        <Controller
          name="recurrence.interval"
          control={control}
          rules={{ required: true, validate: notEmptyString }}
          render={({ field, fieldState: { error } }) => (
            <Wrapper
              id="interval"
              className="w-12"
              showErrorText={false}
              error={!isNil(error)}
              required
            >
              <NumberTextField {...field} inputRef={inputRef} />
            </Wrapper>
          )}
        />
        <Controller
          control={control}
          name="recurrence.repeatType"
          render={({ field }) => (
            <Select<CommonOption>
              {...field}
              id="recurrence-type"
              className="w-28 text-gray-500 text-xs"
              placeholder="Select"
              options={recurrenceOptions}
              getLabel={(option) => option.label}
              getValue={(option) => option.id}
            />
          )}
        />
        {isWeekly && (
          <Controller
            control={control}
            name="recurrence.repeatsOn"
            rules={{ required: true, validate: negate(isEmpty) }}
            render={({ field }) => (
              <MultiChoiceGroup<CommonOption>
                {...field}
                options={daysOfWeek}
                getLabel={(day) => day.label}
                getId={(day) => day.id}
              />
            )}
          />
        )}
      </div>
    </div>
  );
}
